<app-form-input class="radio-group" [parentForm]="parentForm" [disabled]="disabled" [value]="radioButtonValue"
	[label]="step3.getspan23" [type]="'radio'" [rule]="'required'" [errorMessage]="" [radios]="[
			{
				label: step3.entrepriseAdaptee,
				value: radioCheckBoxEnum.entrepriseAdapteeValue
			},
			{
				label: step3.servicesSociaux,
				value: radioCheckBoxEnum.servicesSociauxValue
			},
			{
				label: step3.structureInsertion,
				value: radioCheckBoxEnum.structureInsertionValue
			}
		]" [name]="radioButtonCtrlName">
</app-form-input>